import React from 'react';
import { FcGoogle } from 'react-icons/fc';
import { FaGithub } from 'react-icons/fa';
import './index.css';

/**
 * Renders a SSO login buttons for Google and GitHub.
 */
const OAuthSignIn = ({
  authType,
  handleOAuthSignIn,
}: {
  authType: 'login' | 'signup';
  handleOAuthSignIn: (type: 'google' | 'github') => void;
}) => {
  const signUpText = authType === 'login' ? 'Sign in with' : 'Sign up with';

  return (
    <div className='oauth-container'>
      <h4 className='oauth-signin-text'>Or continue with:</h4>
      <button
        type='button'
        className='oauth-signin-button'
        onClick={() => handleOAuthSignIn('google')}>
        <FcGoogle /> {`${signUpText} Google`}
      </button>
      <button
        type='button'
        className='oauth-signin-button'
        onClick={() => handleOAuthSignIn('github')}>
        <FaGithub className='github-icon' /> {`${signUpText} GitHub`}
      </button>
    </div>
  );
};

export default OAuthSignIn;
